import React from 'react';
import { useParams } from 'react-router';
import { apiUrl } from 'utils/apiUrl';
import { useTranslation } from 'react-i18next';
import { ExecutionDetailsView } from 'components/JobExecution/ExecutionDetailsView';

const CHILD_JOBS_LIMIT = 500;

export const RegionalExecutionDetails: React.FC = () => {
  const { t } = useTranslation();
  const { region, executionId } = useParams<{ region: string; executionId: string }>();
  return (
    <ExecutionDetailsView
      apiPath={apiUrl(
        'lct',
        `regions/${region}/tenantTypes/Regional/jobManager/executions/${executionId}?limit=${CHILD_JOBS_LIMIT}`,
      )}
      title={t('jobService.executionDetail')}
      testIdPrefix="regional-execution"
    />
  );
};

export default RegionalExecutionDetails;
